module.exports = __webpack_public_path__ + "static/media/m_hamburger-menu.1c220e54.svg";